document.addEventListener('alpine:init', () => {
  Alpine.data('flexBlock', () => ({
    id: '',
    breakpoints: [],
    styles: '',

    init() {
      this.$nextTick(() => {
        this.id = this.$el.id;
        this.breakpoints = JSON.parse(this.$refs.breakpoints.innerHTML);

        const styles = [];
        let imgIndex = 0;

        this.styles = this.breakpoints.forEach((breakpoint) => {
          styles.push(`@media screen and (min-width: ${breakpoint.min_screen_width}px) {`);

          // Root
          styles.push(`#${this.id} {`);
          styles.push(`padding-top: ${breakpoint.padding_top};`);
          styles.push(`padding-bottom: ${breakpoint.padding_bottom};`);
          styles.push(`}`);

          // Content
          styles.push(`#${this.id} [x-ref="content"] {`);
          styles.push(`max-width: ${breakpoint.max_content_width};`);

          if (breakpoint.content_position === 'left' || breakpoint.content_position === 'center') {
            styles.push(`margin-right: auto;`);
          }

          if (breakpoint.content_position === 'right' || breakpoint.content_position === 'center') {
            styles.push(`margin-left: auto;`);
          }

          styles.push(`}`);

          // Images
          breakpoint.images.forEach((image) => {
            const imgWrapper = document.createElement('div');
            const imgEl = document.createElement('img');
            imgWrapper.setAttribute('data-image-index', imgIndex);
            imgEl.src = image.image.url;
            imgEl.alt = image.image.alt;
            imgWrapper.append(imgEl);
            this.$refs.images.append(imgWrapper);

            // Image wrapper
            styles.push(`#${this.id} [data-image-index="${imgIndex}"] {`);
            styles.push(`display: block;`);
            styles.push(`opacity: ${image.opacity};`);
            styles.push(`width: ${image.width};`);

            let top = 'auto';
            let right = 'auto';
            let bottom = 'auto';
            let left = 'auto';

            if (image.position === 'top' || image.position === 'top-left' || image.position === 'top-right') {
              top = '0';
            }

            if (image.position === 'right' || image.position === 'top-right' || image.position === 'bottom-right') {
              right = '0';
            }

            if (image.position === 'bottom' || image.position === 'bottom-left' || image.position === 'bottom-right') {
              bottom = '0';
            }

            if (image.position === 'left' || image.position === 'top-left' || image.position === 'bottom-left') {
              left = '0';
            }

            if (image.position === 'center') {
              top = '50%';
              left = '50%';
              styles.push(`transform: translate3d(-50%, -50%, 0);`);
            }

            styles.push(`top: ${top};`);
            styles.push(`right: ${right};`);
            styles.push(`bottom: ${bottom};`);
            styles.push(`left: ${left};`);

            styles.push(`}`);

            // Image
            styles.push(`#${this.id} [data-image-index="${imgIndex}"] img {`);
            styles.push(`transform: translate3d(${image.offset_left}, ${image.offset_top}, 0);`);
            styles.push(`}`);

            // Hide prev images
            for (let i = 0; i < imgIndex; i++) {
              styles.push(`#${this.id} [data-image-index="${i}"] {`);
              styles.push(`display: none;`);
              styles.push(`}`);
            }

            imgIndex++;
          });

          styles.push(`}`);
        });

        this.styles = styles.join('\n');
      });
    },
  }));
});